/* eslint-disable functional/prefer-readonly-type */
import { Autocomplete, Checkbox, TextField, Box } from '@mui/material'
import React, { useState } from 'react'
import useSystemState from '~/features/System/stores/SystemState'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import { useLang } from '~/hooks/useLang'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

export default function SelectAreas() {
  const { windowManager } = useSystemState()
  const { translate } = useLang()
  const [selectIsValidatedAreas, setSelectIsValidatedAreas] = useState<any[]>(
    []
  )

  const optionsSelectAreas = Object.keys(
    windowManager()['mapSetting']['markersView']['areas']['children']
  ).map((areaName, index) => ({
    id: index,
    name: areaName,
  }))
  return (
    <Autocomplete
      multiple
      id="checkboxes-areas"
      options={optionsSelectAreas}
      disableCloseOnSelect
      size="small"
      loading={Boolean(optionsSelectAreas.length > 0)}
      value={selectIsValidatedAreas}
      onChange={(event, newValue, reason, details) => {
        const previousValue = selectIsValidatedAreas

        if (reason === 'selectOption' && details?.option) {
          const areaName = details.option.name
          windowManager()['mapSetting']['markersView']['areas']['children'][
            areaName
          ].show.set(true)
        } else if (reason === 'removeOption' && details?.option) {
          const areaName = details.option.name
          windowManager()['mapSetting']['markersView']['areas']['children'][
            areaName
          ].show.set(false)
        } else if (reason === 'clear') {
          previousValue.forEach((area) => {
            windowManager()['mapSetting']['markersView']['areas']['children'][
              area.name
            ].show.set(false)
          })
        }

        setSelectIsValidatedAreas(JSON.parse(JSON.stringify(newValue)))
      }}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderOption={(props, option, { selected }) => {
        const { id, ...optionProps } = props
        return (
          <li key={id} {...optionProps}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            <Box component="span" sx={{ color: 'text.primary' }}>
              {option.name}
            </Box>
          </li>
        )
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={translate('Areas')}
          placeholder={translate('Select areas')}
          sx={{
            '& .MuiInputBase-input': {
              color: 'text.primary'
            },
            '& .MuiInputLabel-root': {
              color: 'text.secondary'
            },
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: 'rgba(255, 255, 255, 0.23)'
              },
              '&:hover fieldset': {
                borderColor: 'rgba(255, 255, 255, 0.4)'
              },
              '&.Mui-focused fieldset': {
                borderColor: 'primary.main'
              }
            },
            '& .MuiChip-root': {
              color: 'text.primary',
              backgroundColor: 'action.selected'
            },
            '& .MuiChip-deleteIcon': {
              color: 'text.secondary'
            }
          }}
        />
      )}
    />
  )
}
